import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { santaBarbaraConfig } from "./data";

export default function SantaBarbaraPage() {
  return <CityPageTemplate config={santaBarbaraConfig} />;
}